import { Component } from '@angular/core';
import { BreadcrumbService } from 'ng5-breadcrumb';
import { LotacoesId } from "app/entity/enumeraveis";
import { BaseListComponent } from 'app/base';

@Component({
    selector: 'prestacao-conta',
    templateUrl: 'prestacao-conta.component.html'
})

export class PrestacaoContaComponent extends BaseListComponent {
    controllerName = 'prestacaoConta';
    valid: boolean;
    filtro = this.formBuilder.group({
        query: [null]
    });

    showAlert = false;

    init() {
        const localStorageId = localStorage.getItem('lotacao')
        if (localStorageId === LotacoesId.CRC_SP.toString()) {
            this.showAlert = true;
        }
        this.listagem.pDatatableComponent.sortOrder = 2;
        this.carregarEstado();
    }
}



// WEBPACK FOOTER //
// ./src/app/prestacao-conta/prestacao-conta.component.ts